import AsyncStorage from "@react-native-async-storage/async-storage";
import { LinearGradient } from "expo-linear-gradient";
import React, { useEffect, useState } from "react";
import { Image, ScrollView, Text, View } from "react-native";
import DropDownPicker from "react-native-dropdown-picker";
import { TouchableOpacity } from "react-native-gesture-handler";
import NumberInput from "../../components/NumberInput";
import Button from "../../components/Button";
import HeaderDefault from "../../components/HeaderDefault";
import activesService from "../../services/activesService";
import styles from "./styles";
import balanceService from '../../services/balanceService';
import { maxDecimals } from "../../utils/formatNumber";

const PaperWallet = ({ navigation }) => {

  const defaultItem = {
    label: 'GPX/BRL',
    value: -1,
    icon: () => (
      <Image source={require('../../../assets/imgs/gpx.png')} style={styles.iconSelect} />
    ),
  };

  const [items, setItems] = useState([defaultItem]);
  const [balance, setBalance] = useState("");

  const [amount, setAmount] = useState(0);
  const [selectedActive, setSelectedActive] = useState(null);
  const [selectedActiveObj, setSelectedActiveObj] = useState(null);

  const [price, setPrice] = useState(0.0);
  const [authToken, setAuthToken] = useState(null);

  const [actives, setActives] = useState([]);
  const [open, setOpen] = useState(false);

  const [minPaperWallet, setMinPaperWallet] = useState(1);

  const [decimals, setDecimals] = useState(0);

  const [amountToken, setAmountToken] = useState(0);

  DropDownPicker.addTranslation("PT", {
    PLACEHOLDER: "Selecione...",
    NOTHING_TO_SHOW: "Nada para mostrar!"
  });
  DropDownPicker.setLanguage("PT");

  useEffect(() => {
    //let itemsAr = [defaultItem];
    let itemsAr = [];
    actives.map((el) => {
      itemsAr.push({
        label: el.name_token,
        value: el.id,
        icon: () => (
          <Image
            source={{
              uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${el.path}`,
            }}
            style={styles.iconSelect}
          />
        ),
      });
    });
    setItems(itemsAr);
  }, [actives]);

  useEffect(() => {
    // console.log('items');
    // console.log(items);
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    if (parseInt(selectedActive + '') === -1) {
      setSelectedActiveObj({
        id: -1,
        name_token: 'GPX/BRL',
        single_value: 1,
        amount_token: '='
      })
      loadBalanceGPX();
    } else {
      actives.map((el) => {
        if (el.id === selectedActive) {
          setSelectedActiveObj(el);
          if (el.single_value) {
            setPrice(parseFloat(el.single_value));
          }
          if(el.name_token) {
            if(['BTC', 'ETH', 'ADA'].indexOf(el.name_token) !== -1)
              setDecimals(8);
          }
          if(!el.cryptoactive && ['BTC', 'ETH', 'ADA'].indexOf(el.name_token) === -1) {
              loadAmountToken();
          }else{
              setAmountToken(0);
          }
        }
      });
      loadBalance();
    }
  }, [selectedActive]);

  useEffect(() => {
    if (authToken) {
      loadActivesWithBalance();
    }
  }, [authToken]);

  useEffect(() => {
    calcMinPaperWallet();
  }, [selectedActiveObj]);

  const loadAmountToken = async () => {
      if(authToken) {
          activesService.getById(authToken, selectedActive).then((response) => {
              if(response.data?.count) {
                  setAmountToken(response.data?.count);
              }
          });
      }
  }

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const loadActivesWithBalance = () => {
    activesService.getActivesWhereUserHasBalance(authToken).then((response) => {
      if (response.data.length > 0) {
        setActives(response.data);
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  const loadBalance = () => {
    if (authToken) {
      balanceService.getBalanceOfToken(authToken, selectedActive).then((response) => {
        setBalance(response?.data?.saldo + '');
      }).catch((error) => {
      });
    }
  }

  const loadBalanceGPX = () => {
    if (authToken) {
      balanceService.getBalanceOfGpx(authToken).then((res) => {
        if (res.data.balance[0]?.available_balance) {
          setBalance(res.data.balance[0].available_balance);
        } else {
          setBalance(res.data.balance[0].saldo);
        }
      }).catch((error) => {
      });
    }
  }

  const calcMinPaperWallet = () => {
    if (selectedActiveObj) {
      if (selectedActiveObj.name_token === 'BTC') {
        setMinPaperWallet(0.0008);
      } else if (selectedActiveObj.name_token === 'ADA') {
        setMinPaperWallet(10);
      } else if (selectedActiveObj.name_token === 'ETH') {
        setMinPaperWallet(0.016);
      } else if (selectedActiveObj.name_token === 'GPX/BRL') {
        setMinPaperWallet(10);
      } else {
        setMinPaperWallet(1);
      }
    }
  }

  const setAmountOverride = (amount) => {
      if (selectedActiveObj) {
          if (!selectedActiveObj.cryptoactive) {
              setAmount(parseInt(amount + ''));
          }else{
              setAmount(amount + '');
          }
      }else{
          setAmount(amount + '');
      }
  }

  return (
    <>
      <HeaderDefault title={"Paper Wallet"} />


      <Text style={styles.title}>Desejo sacar:</Text>

      <View style={styles.contentSelect}>
        <DropDownPicker
          open={open}
          value={selectedActive}
          items={items}
          containerStyle={styles.dropdown}
          placeholder="Selecione"
          setOpen={setOpen}
          setValue={setSelectedActive}
          setItems={setItems}
        />
      </View>
      <ScrollView style={styles.content}>
        {selectedActive ? (
          <>
            <View style={{ flexDirection: "row", display: "flex" }}>
              <Text
                style={{ ...styles.textAmount, flex: 0.5, fontWeight: "400" }}
              >
                Preço
              </Text>
              <Text
                style={{ ...styles.textAmount, flex: 0.5, textAlign: "right" }}
              >
                {selectedActiveObj && selectedActiveObj.single_value} GPX
              </Text>
            </View>
            <View>
              <Text style={{ textAlign: "right", color: "#999999" }}>
                {selectedActiveObj && selectedActiveObj.single_value} BRL
              </Text>
            </View>

            <View
              style={{ flexDirection: "row", marginTop: 15, marginBottom: 15 }}
            >
              <View style={{ flex: 0.5 }}>
                {
                  selectedActive !== -1 &&
                  <Text style={{ fontWeight: "700", fontSize: 16 }}>
                    {
                        !selectedActiveObj?.cryptoactive && parseInt(amountToken) > 0 &&
                        <Text style={{ fontWeight: '700', fontSize: 16 }}>Quantidade disponível{"\n"}<Text style={{ fontWeight: '400', color: '#656565' }}>{amountToken} {selectedActiveObj && selectedActiveObj.name_token}</Text></Text>
                    }
                  </Text>
                }
              </View>
              <View style={{ flex: 0.5 }}>
                <Text
                  style={{
                    textAlign: "right",
                    fontWeight: "700",
                    fontSize: 16,
                  }}
                >
                  Meu saldo{"\n"}
                  <Text style={{ fontWeight: "400", color: "#656565" }}>
                    {
                    selectedActiveObj?.cryptoactive ? maxDecimals(balance, 8) : maxDecimals(balance, 0)
                    }{" "}
                    {selectedActiveObj && selectedActiveObj.name_token}
                  </Text>
                </Text>
              </View>
            </View>
            <View style={styles.contentPurchase}>
              <Text style={styles.titlePurchase}>
                Quantas unidades deseja colocar na Paper Wallet?
              </Text>
              <View style={styles.contentPurchaseAmount}>
                <NumberInput
                  minValue={0}
                  value={amount}
                  maxDecimalsParam={decimals}
                  onChange={value => setAmountOverride(value)} />
              </View>
            </View>
          </>
        ) : (
          <>
            <View style={{ padding: 15, marginTop: 50, marginBottom: 50 }}>
              <Text style={{ textAlign: "center" }}>
                Antes de continuar, selecione o ativo que deseja sacar.
              </Text>
            </View>
          </>
        )}
      </ScrollView>
      <View style={styles.contentBtn}>

        {selectedActive ? (
          amount && parseFloat(amount + '') >= minPaperWallet ? (
            parseFloat(amount + '') > parseFloat(balance) ? (
              <TouchableOpacity onPress={() => navigation.navigate('DepositMethod')}>
                <LinearGradient
                  start={{ x: -1, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={["#16195B", "#1FBFB5"]}
                  style={styles.btn}
                >
                  <Text style={styles.textBtn}>SALDO INSUFICIENTE</Text>
                </LinearGradient>
              </TouchableOpacity>

            ) : (
              <TouchableOpacity
                disabled={amount <= 0 ? true : false}
                onPress={() =>
                  navigation.navigate({
                    name: "ConfirmPaperWallet",
                    params: { token: selectedActive, qtd: amount },
                  })
                }
              >
                <LinearGradient
                  start={{ x: -1, y: 0 }}
                  end={{ x: 1, y: 0 }}
                  colors={["#16195B", "#1FBFB5"]}
                  style={styles.btn}
                >
                  <Text style={styles.textBtn}>CONTINUAR</Text>
                </LinearGradient>
              </TouchableOpacity>

            )
          ) : (
            <TouchableOpacity disabled={true}>
              <LinearGradient
                start={{ x: -1, y: 0 }}
                end={{ x: 1, y: 0 }}
                colors={["#16195B", "#1FBFB5"]}
                style={styles.btn}
              >
                <Text style={styles.textBtn}>MÍNIMO DE {minPaperWallet} {selectedActiveObj?.name_token}</Text>
              </LinearGradient>
            </TouchableOpacity>
          )
        ) : (
          <TouchableOpacity disabled={true}>
            <LinearGradient
              start={{ x: -1, y: 0 }}
              end={{ x: 1, y: 0 }}
              colors={["#16195B", "#1FBFB5"]}
              style={styles.btn}
            >
              <Text style={styles.textBtn}>SELECIONE UM ATIVO</Text>
            </LinearGradient>
          </TouchableOpacity>
        )}
      </View>
    </>
  )
}
export default PaperWallet;
